import { Fragment, useEffect } from "react";
import MainContainer from "../../components/container/MainContainer";
import { useDispatch, useSelector } from "react-redux";
import {
  getAccountTypes,
  unsetAccountTypes,
} from "../../features/accountsSlice";
import Modal from "../../components/modal/Modal";
import AddAccount from "./AddAccount";
import { openModal } from "../../features/modalSLice";
import Loading from "../../components/loading/Loading";
import Table from "../../components/tables/Table";
import loadStatus from "../../util/loadStatus";
import NetworkError from "../error/NetworkError";
import { useLocation } from "react-router-dom";

const ChartReport = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const accountTypes = useSelector((state) => state.accounts.accountTypes);
  const loading = useSelector((state) => state.accounts.load.getAccountTypes);
  const modalContent = useSelector((state) => state.modal.content);

  const openModifyAccountModal = (e, id) => {
    e.preventDefault();
    dispatch(openModal(<AddAccount edit id={id} />));
  };

  useEffect(() => {
    dispatch(getAccountTypes());
    return () => {
      dispatch(unsetAccountTypes());
    };
  }, []);

  if (loading === loadStatus.loading) {
    return <Loading />;
  }

  if (loading === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <MainContainer>
      <Modal>{modalContent}</Modal>
      <h3 className="text-text-1/80">Chart Reports</h3>
      <div className="flex flex-col items-start justify-start gap-10">
        {accountTypes.length >= 1 &&
          accountTypes.map((item, index) => (
            <Fragment key={item.id}>
              <div>
                <h4 className="text-primary">{item.name}</h4>
                <div className="pl-3">
                  <h5 className="text-orange-500">Non Categorized</h5>
                  <div className="pl-3 pb-3">
                    {item.accounts.map((item, index) => (
                      <p key={item.id}>
                        <button
                          key={item.id}
                          onClick={(e) => {
                            openModifyAccountModal(e, item.id);
                          }}
                          className="text-text-1/60 "
                        >
                          {item.name}
                        </button>
                      </p>
                    ))}
                  </div>
                </div>
                <div className="pl-3">
                  {item.account_categories.map((item, index) => (
                    <Fragment key={item.id}>
                      <h5 className="text-orange-500">{item.name} </h5>
                      <div className="pl-3 pb-3">
                        {item.accounts.map((item, index) => (
                          <p key={item.id}>
                            <button
                              key={item.id}
                              onClick={(e) => {
                                openModifyAccountModal(e, item.id);
                              }}
                              className="text-text-1/60"
                            >
                              {item.name}
                            </button>
                          </p>
                        ))}
                      </div>
                    </Fragment>
                  ))}
                </div>
              </div>
            </Fragment>
          ))}
      </div>

      <div>
        <Table columns={[]} data={[]} />
      </div>
    </MainContainer>
  );
};

export default ChartReport;
